import { ROUTING_AUTO, ROUTING_MARKETPLACE, ROUTING_SHOP } from './utils';

// ---------------------------------------------------------------------------
// SKIPPED FIELDS
//
// The redesign (Figma: Corporate Account — Discovery, node 16587-3305) introduces columns
// with no backing column on `clients`. Per eng-manager direction these render blank rather
// than faked — the cell, its width and its row height are preserved (see `Skipped` in
// blocks.js), so restoring one is a matter of swapping the accessor back in.
//
// `values` records the enums the designer annotated on the Figma canvas. They have nowhere
// to be stored yet; they are kept here so the work survives until the columns land.
//
// To find every skipped field: grep for SKIPPED_FIELDS and `Skipped` in this directory.
// ---------------------------------------------------------------------------
export const SKIPPED_FIELDS = {
    stage: {
        // The designer's comment on this chip repeats the Owner comment verbatim — a
        // copy/paste slip, so Stage has no stated source yet. The enum below came off the
        // canvas annotation.
        label: 'Stage',
        values: [
            'Deal Received',
            'Deal Scoping',
            'Solutioning',
            'Round 1 Pricing',
            'Round 1 Pricing Submitted',
            'Round 1 Pricing Feedback',
            'Round 2 Pricing',
            'Round 2 Pricing Submitted',
            'Round 2 Pricing Feedback',
            'Verbal Agreement',
            'Deal Lost',
            'Onboarding',
            'Go live',
            'Deal won',
        ],
    },
    owner: {
        label: 'Owner',
        note: 'designer: pull from whoever created the record — scoped to the Roles and Permissions sprint',
    },
    commodity: {
        label: 'Commodity',
        note: 'renamed from Vertical by the designer — this column is product commodity type',
        values: ['Furniture & Mattresses', 'Appliances & Electronics', 'Exercise Equipment'],
    },
    stacksBy: { label: 'Stacks By' },
    coverage: { label: 'Coverage' },
    footprint: { label: 'Footprint', note: 'shipper sub-line, e.g. "Texas · 18 metros"' },
    lastUpdated: { label: 'Last updated', note: 'table footer timestamp' },
};

export const EMPTY_VALUE = '—';

// One chip per `clients.shipper_type` value. Marketplace is not in the Figma — the designer
// asked for it "for now but will go away", so expect to delete this entry, not restyle it.
export const ROUTING_CHIPS = [
    { mode: ROUTING_AUTO, label: 'Auto' },
    { mode: ROUTING_SHOP, label: 'Shop' },
    { mode: ROUTING_MARKETPLACE, label: 'Marketplace' },
];

export const ROUTING_FILTER_OPTIONS = [
    { value: 'AUTO_ASSIGN', label: 'Auto' },
    { value: 'RATE_SHOP', label: 'Shop' },
    { value: 'MARKETPLACE', label: 'Marketplace' },
];

// Column order and widths follow the Figma. `filter` attaches an OptionFilter caret to the
// header — only columns backed by real data get one, so no caret is ever a no-op.
export const SHIPPER_COLUMNS = [
    { key: 'shipper', label: 'Shipper' },
    { key: 'stage', label: 'Stage', width: 95 },
    { key: 'owner', label: 'Owner', width: 75 },
    { key: 'commodity', label: 'Commodity', width: 165 },
    { key: 'orderEntry', label: 'Order Entry', width: 105 },
    {
        // Wider than the Figma's 155: that sized two chips, and the designer asked for a third.
        // Drop back to 155 when Marketplace goes away.
        key: 'routing',
        label: 'Routing',
        width: 240,
        filter: { key: 'shipper_type', options: ROUTING_FILTER_OPTIONS },
    },
    { key: 'stacksBy', label: 'Stacks By', width: 125 },
    { key: 'profiles', label: 'Profiles', width: 135 },
    { key: 'coverage', label: 'Coverage', width: 100 },
    { key: 'actions', label: 'Actions', width: 120, align: 'right' },
];
